<script context="module">import { pipe, toString } from "rambda";
const memoizedOutput = /* @__PURE__ */ new Map();
const memoize = (atts, fn) => {
  const cacheKey = JSON.stringify(Object.entries(atts));
  if (memoizedOutput.has(cacheKey)) {
    return memoizedOutput.get(cacheKey);
  }
  const output = fn();
  memoizedOutput.set(cacheKey, output);
  return output;
};
const overrideParams = (params) => (url) => {
  let newUrl;
  try {
    newUrl = new URL(url);
  } catch (cause) {
    throw new Error(`Could not parse nor create new url in Image component: ${url}`, {
      cause
    });
  }
  for (let [key, value] of Object.entries(params)) {
    newUrl.searchParams.set(key, String(value));
  }
  return newUrl;
};
const decorateSrc = (url, params) => pipe(overrideParams(params), toString)(url);
</script>

<script>export let src;
export let w = void 0;
export let h = void 0;
export let q = 75;
$:
  defaultParams = { q };
$:
  [at1x, at2x] = memoize($$props, () => {
    if (!src) {
      return ["", ""];
    }
    const srcUrl = new URL(src);
    if (!srcUrl.origin.includes("gxcorner")) {
      return [src, src];
    }
    if (!w || !h) {
      const both = decorateSrc(srcUrl, defaultParams);
      return [both, both];
    }
    let params1x = { ...defaultParams, w, h, c: true };
    let params2x = {
      ...defaultParams,
      w: Math.round(w * 2),
      h: Math.round(h * 2),
      c: true
    };
    return [decorateSrc(srcUrl, params1x), decorateSrc(srcUrl, params2x)];
  });
</script>

{#if at1x && at2x}
  <slot {at1x} {at2x} />
{/if}
